var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.external)?_c('router-link',{staticClass:"menu-title",attrs:{"to":_vm.link}},[_vm._t("default")],2):(_vm.external)?_c('a',{staticClass:"menu-title",attrs:{"href":_vm.link,"target":"_blank"}},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }